if (!window.HoculusRadio) {
    class HoculusRadio extends HTMLElement {
        radioTextEl = this.querySelector(".radio__text");
        radioIcon = this.querySelector(".radio__icon");

        radioGroupId = this.dataset.radioGroupId;

        productFormSelector = this.dataset.productFormSelector;
        productForm = document.querySelector(this.productFormSelector);

        propertyFor = this.dataset.propertyFor;

        index = this.dataset.index;

        productTitle = this.dataset.productTitle;

        constructor() {
            super();
            window.hoculusRadioFormRegister = window.hoculusRadioFormRegister || [];
            this.addEventListener("click", this.handleRadioClick.bind(this));

            // Adds submit event listener to the product form to override the original submit event. This is done if the product form is not already registered
            this.handleProductFormSubmit();
        }

        // This method handles click event on the radio info icon and radio inputs
        handleRadioClick(el) {
            // Display not selected text when clicking on the not-selected radio input
            this.classList.add("radio__text--active");

            // Remove radio icon
            this.radioIcon?.remove();

            // Update textEl style by adding/removing has-error attribute, this attribute is added in product-form.js on add to cart action
            this.removeAttribute("has-error");

            // Set textEl value to be currently selected radio input
            this.radioTextEl.textContent = el.value;
            this.radioTextEl.style.fontSize = "16px";
            // Remove old inputs by group id
            this.removeOldInputs(`input[radio-group-id-${this.radioGroupId}]`);

            // Show bigger preview image
            const previewImg = this.querySelector(".radio__preview--placeholder-image-wrapper > img");
            const previewImgUrl = el.nextElementSibling.dataset.previewImg;

            if(previewImg && previewImgUrl) {
                previewImg.srcset = "";
                previewImg.src = previewImgUrl;
                previewImg.parentElement.setAttribute("image-selected", true);
            }

            if (el.id === `${this.index}-not-selected`) {
                previewImg.parentElement.setAttribute("image-selected", false);        
                return;
            }
        }


        removeOldInputs(groupSelector) {
            this.productForm.querySelectorAll(groupSelector).forEach(input => input.remove());
        }

        handleRadioIconClick() {
            if (this.querySelector("input:checked")) return;
            this.classList.toggle("radio__text--active");
        }

        appendInputsHTML(inputsHTML) {
            this.productForm.insertAdjacentHTML("beforeend", inputsHTML);
        }

        handleProductFormSubmit() {
            if (!window.hoculusRadioFormRegister.includes(this.productFormSelector)) {
                window.hoculusRadioFormRegister.push(this.productFormSelector);

                this.productForm.addEventListener("submit", (event) => {
                    const radioComponents = document.querySelectorAll(`.hoculus-radio [radio-component][data-product-form-selector="${this.productFormSelector}"]`);
                    // Ogni gruppo deve avere almeno un radio scelto (non contare il totale dei checked: due radio scelti nello stesso gruppo bloccavano l'invio senza errori)
                    const selectedEnough = Array.from(radioComponents).every((component) => component.querySelector("input:checked"));

                    let scrolled = false;

                    if (!selectedEnough) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        for (const radioComponent of radioComponents) {
                            radioComponent.classList.add("radio__text--active");
                            const notSelectedRadio = radioComponent.querySelector("input:checked");
                            if (!scrolled && !notSelectedRadio) {
                                radioComponent.scrollIntoView({ behavior: "smooth", block: "center" });
                                scrolled = true;
                            }
                            if (!notSelectedRadio) {
                                radioComponent.setAttribute("has-error", true);
                                const radioTextEl = radioComponent.querySelector(".radio__text");
                                radioTextEl.textContent = radioComponent.dataset.radioDefaultText;
                            }
                        }
                    }

                }, true);
            }
        }
    }


    if (!customElements.get("hoculus-product-addon-radio")) {
        class HoculusAddonRadio extends HoculusRadio {
            constructor() {
                super();
            }

            // This method handles click event on the radio info icon and radio inputs
            handleRadioClick(event) {
                const el = event.target;
                // Target validation (only radio inputs and radio icon are allowed to be clicked)
                if (el?.type !== "radio" && !el?.classList.contains("radio__icon")) return true;

                // Check if the radio icon is clicked
                if (el?.classList.contains("radio__icon")) {
                    this.handleRadioIconClick();
                    return;
                }
                // End of target validation

                super.handleRadioClick(el);

                const productId = el.dataset.productId;

                // If the not selected option is selected, remove all inputs and return
                if (productId === `${this.index}-not-selected`) return;
                
                // Generate and append new inputs
                const inputsHTML = this.generateInputsHTML(productId);
                this.appendInputsHTML(inputsHTML);
            }

            generateInputsHTML(variantId) {
                return `
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="items[${this.index}][id]" value="${variantId}">
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="items[${this.index}][quantity]" value="1">
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="items[${this.index}][properties][${this.propertyFor}]" value="${this.productTitle}">
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="items[${this.index}][properties][_rifId]" value="${variantId}">
                `;
            }
        }

        customElements.define("hoculus-product-addon-radio", HoculusAddonRadio);
    }

    if (!customElements.get("hoculus-product-attribute-radio")) {
        class HoculusCartAttributeRadio extends HoculusRadio {
            attributeName = this.dataset.attributeName;

            constructor() {
                super();
            }

            // This method handles click event on the radio info icon and radio inputs
            handleRadioClick(event) {
                const el = event.target;
                // Target validation (only radio inputs and radio icon are allowed to be clicked)
                if (el?.type !== "radio" && !el?.classList.contains("radio__icon")) return true;

                // Check if the radio icon is clicked
                if (el?.classList.contains("radio__icon")) {
                    this.handleRadioIconClick();
                    return;
                }
                // End of target validation

                super.handleRadioClick(el);

                const productId = el.dataset.productId;

                // If the not selected option is selected, remove all inputs and return
                if (productId === `${this.index}-not-selected`) return;

                // Generate and append new inputs
                const inputsHTML = this.generateInputsHTML(productId, el.value);
                this.appendInputsHTML(inputsHTML);
            }

            generateInputsHTML(variantId, attributeValue) {
                return `
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="properties[${this.attributeName}]" value="${attributeValue}">
                    <input type="hidden" radio-group-id-${this.radioGroupId} name="properties[_rifId]" value="${variantId}">
                `;
            }
        }

        customElements.define("hoculus-product-attribute-radio", HoculusCartAttributeRadio);
    }
}